import { Moment } from 'moment';

export const getDays = (startDate: Moment, noOfDays = 7): Moment[] =>
  [...Array(noOfDays)].map((value, index) => startDate.add(index, 'day'));
